import React from 'react';
import { LogoIcon, LogoIconSmall } from './logo.styled';
import LogoPng from '../../assets/image/logo_pr.png';

export function LogoSmall() {
  return <LogoIconSmall src={LogoPng} />;
}

function Logo() {
  return <LogoIcon src={LogoPng} />;
}

export default Logo;
